﻿import { IComponent, Component, Input } from "@fiqas/angular-utils";
import { FIQAssist  } from "../../app";
import { ServiceCaseService } from "../../services/fiqassistApi/serviceCaseService"

@Component({
    module: FIQAssist,
    selector: 'durationpanel',
    template: `<span class='durationpanel' ng-show="$ctrl.durationText != null">{{'IN_PROGRESS_BEFORE_TEXT' | translate}} {{$ctrl.durationText}} {{$ctrl.durationUnits | translate}} {{'IN_PROGRESS_AFTER_TEXT' | translate}} <span style="font-size:22px;" class="icon-timer"></span><br /></span>`
})
export class DurationPanel implements IComponent {
    private _duration: number;
    private durationText: string;
    private durationUnits: string;

    @Input()
    public get duration(): number {
        return this._duration;
    }
    public set duration(dur: number) {
        this._duration = dur;
        this.makeText();
    }

    private makeText() {
        {
            if (this._duration != undefined) {
                if (this._duration < 60) {
                    this.durationText = this._duration + '';
                    this.durationUnits = 'MINUTES';
                } else if (this._duration < 1140) {
                    this.durationText = Math.floor(this._duration / 60) + '';
                    this.durationUnits = 'HOURS';
                } else {
                    this.durationText = Math.floor(this._duration / 1440) + '';
                    this.durationUnits = 'DAYS';
                }
            } else {
                this.durationText = null;
                this.durationUnits = null;
            }
        }
    }
}
